import { css } from '@emotion/css';

import { cn } from '@lyearn/style';
import { BaseCardImageTransitionType } from '@/modules/content/components/ContentCard/BaseCard/types';

const TRANSITION_CLASSNAME = 'transform transition-all duration-500 ease-out';

export const TRANSITION_CLASSES = {
  [BaseCardImageTransitionType.GroupHover]: cn(TRANSITION_CLASSNAME, 'group-hover:scale-105'),
  [BaseCardImageTransitionType.Hover]: cn(TRANSITION_CLASSNAME, 'hover:scale-105'),
};

export const imageOverlayStyles = css`
  background-color: rgba(0, 0, 0, 0.1);
`;
